import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryDropdown from './components/CategoryDropdown';
import WhatIsSection from './components/WhatIsSection';
import WhySection from './components/WhySection';
import ComparisonTable from './components/ComparisonTable';
import CategoryCards from './components/CategoryCards';
import SafetySection from './components/SafetySection';
import FAQSection from './components/FAQSection';
import ArticlePreview from './components/ArticlePreview';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryDropdown />
        <WhatIsSection />
        <WhySection />
        <ComparisonTable />
        <CategoryCards />
        <SafetySection />
        <FAQSection />
        <ArticlePreview />
      </main>
      <Footer />
    </div>
  );
}